











































import {
  ChoiceQuestion,
  Component,
  ComponentConfig,
  ComponentStyle,
  ComponentStyleDefinition,
  InjectComponent,
  Vue,
  VueComponent,
  Prop,
} from "@zoovu/runner-browser-api";

import { ChoiceQuestionView, QuestionConfiguration } from "@zoovu/runner-web-design-base";

@Component({
  name: "ChoiceQuestionView",
  mixins: [ChoiceQuestionView],
})
export default class ChoiceQuestionViewExtended extends Vue {
  @Prop()
  private question: ChoiceQuestion;

  @ComponentConfig(QuestionConfiguration)
  private componentConfiguration: QuestionConfiguration;

  @ComponentStyle()
  componentStyle: ComponentStyleDefinition;

  @InjectComponent("RadioButtonAnswerView")
  radioButtonAnswerView: VueComponent;

  @InjectComponent("CheckboxAnswerView")
  checkboxAnswerView: VueComponent;

  @InjectComponent("QuestionHeadView")
  questionHeadView: VueComponent;

  public minAnswersPerRow = 2;

  private updateAnswerTextHeight(): void {
    /* eslint-disable no-param-reassign */
    this.maxTextHeights = (this.$refs.answerElement as Vue[]).reduce(
      (maxTextHeights, { $children: [choiceAnswer] }, index) => {
        if (
          choiceAnswer.answer.hasInfoText &&
          !(choiceAnswer.$refs.infoTextElement as HTMLElement) &&
          !(choiceAnswer.$refs.answerTextElement as HTMLElement)
        ) {
          return maxTextHeights;
        }

        const infoTextElement = choiceAnswer.$refs.infoTextElement as HTMLElement;
        const rectInfoHeight = choiceAnswer.answer.hasInfoText && infoTextElement?.getBoundingClientRect
            ? infoTextElement.getBoundingClientRect().height : 0;


        const answerTextElement = choiceAnswer.$refs.answerTextElement as HTMLElement;
        const rectAnswerHeight = answerTextElement?.getBoundingClientRect ? answerTextElement.getBoundingClientRect().height : 0;

        const topKey = this.answersPerRow[index];

        if (maxTextHeights[topKey] === undefined) {
          maxTextHeights[topKey] = {
            infoTextHeight: 0,
            answerTextHeight: 0,
          };
        }

        if (maxTextHeights[topKey].infoTextHeight < rectInfoHeight) {
          maxTextHeights[topKey].infoTextHeight = rectInfoHeight;
        }

        if (maxTextHeights[topKey].answerTextHeight < rectAnswerHeight) {
          maxTextHeights[topKey].answerTextHeight = rectAnswerHeight;
        }

        return maxTextHeights;
      },
      []
    );
    /* eslint-enable no-param-reassign */
  }
}
